import * as React from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';

export default function VideoLink ({ record}) {
    let url = record.url;
    if(url !== null) {
        let video_res = url.slice(-4);
        let video_reslink = url.replace('m3u8', 'mp4');
        if (video_res === 'm3u8') {
            return (
                <a href={video_reslink}>
                    <GetAppIcon style={{color: 'rgb(129 129 129)'}}/>
                </a>
            );
        }
    }
    return null;
};